import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_BUCKET,
      region: process.env.REACT_APP_AWS_REGION,
    },
  },
});

const getUserId = () => {
  return Auth.currentAuthenticatedUser().then((user) => {
    return user ? user.attributes.sub : "";
  });
};

const isManaging = () => getRole().then((r) => r.includes("Managing"));
const isDivision = () => getRole().then((r) => r.includes("Division"));

const getRole = () => {
  return Auth.currentAuthenticatedUser().then((user) => {
    return user ? user.attributes["custom:role"] : "";
  });
};

const getRoleName = async () => {
  return getRole().then((role) => role || "");
};

export const Aws = {
  getUserId,
  getRoleName,
  isDivision,
  isManaging,
};
